import { jsx } from "react/jsx-runtime";
const CrehanaIso = ({ className, color: colorProp = '#4B22F4', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    return /*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            d: "M8 0H0v8h8v8H0v8h8v-8h8v8h8V0h-8v8H8V0Z",
            fill: color
        })
    });
};
const logos_CrehanaIso = CrehanaIso;
export default logos_CrehanaIso;
